'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isObjectEqual(a, b) {
  if (!a || !b) {
    return a === b;
  }
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every((key) => {
    const aVal = a[key];
    const bVal = b[key];
    if (typeof aVal === "object" && typeof bVal === "object") {
      return isObjectEqual(aVal, bVal);
    }
    return aVal === bVal;
  });
}
function objectValueOrDefault(obj, key) {
  if (!key) {
    return obj.DEFAULT;
  }
  const result = obj[key];
  if (result !== void 0) {
    return result;
  }
  return obj.DEFAULT;
}

exports.isObjectEqual = isObjectEqual;
exports.objectValueOrDefault = objectValueOrDefault;
